export default __webpack_public_path__ + "static/media/rupee-icon.8a855e5f.svg";